// test653
(653 && 0);
